import { useState, useRef, useEffect } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import parse from "html-react-parser";
import useBucketName from "hooks/useBucketName.ts";

const GetFormScript = ({ form }) => {
  const { getTextByKey, getLanguage } = useContent();
  const bucketName = useBucketName();
  const [scriptOrIframe, setScriptOrIframe] = useState("script");
  const [exampleScript, setExampleScript] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const textAreaRef = useRef(null);
  //Copy the textarea value
  const copyTextAreaToClibord = () => {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    setIsCopied(true);
  };

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  }, [isCopied]);

  //get script/iframe code
  const getExampleScript = async (type) => {
    setScriptOrIframe(type);
    if (type === "iframe") {
      setExampleScript(getIframe());
    } else {
      setExampleScript(getScript());
    }
  };
  useEffect(() => {
    if (bucketName) {
      getExampleScript("script");
    }
  }, [bucketName]);

  const getIframe = () => {
    const src = `https://${bucketName}/${getLanguage()}/form/${
      form.Embed_Dynamic_Id
    }`;
    return `<iframe src="${src}" allowtransparency="true" scrolling="no" frameborder="0" width="${form.Embed_Dynamic_Width}px" height="${form.Embed_Dynamic_Height}px"></iframe>`;
  };

  const getScript = () => {
    return `<script src="https://api.${bucketName}/EmbedDynamics/Form?id=${form.Embed_Dynamic_Id}" type="text/javascript"></script>`;
  };

  return (
    <div className="form-scripts-modal">
      <div className="form-script">
        <div className="title">
          <h2>{getTextByKey("embed-code")}</h2>
        </div>
        <p>{parse(getTextByKey("jumboforms-script-instructions"))}</p>
        <div className="get-links">
          <span
            onClick={() => getExampleScript("script")}
            className={scriptOrIframe === "script" ? "active" : ""}
          >
            Script
          </span>{" "}
          <span
            onClick={() => getExampleScript("iframe")}
            className={scriptOrIframe === "iframe" ? "active" : ""}
          >
            Iframe
          </span>
        </div>
        <div className="script-line">
          <div className="script-code">
            <textarea ref={textAreaRef} value={exampleScript}></textarea>
          </div>
          <div className="copy-icon" onClick={() => copyTextAreaToClibord()}>
            <Icon title={getTextByKey("jumboforms-copy-code")} name="copy-b" />
            {isCopied && (
              <div>
                <span className="copied-text">
                  {getTextByKey("copied-text")}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetFormScript;
